import gql from "graphql-tag";
import { User } from "../types/User";
import { ReturnMessage } from "../types/ReturnMessage";

export const ADMIN_LOGIN_MUTATION = gql`
  mutation AdminLogin(
    $email: String!
    $password: String!
    $eval: Boolean!
    $locale: String!
  ) {
    adminLogin(
      email: $email
      password: $password
      eval: $eval
      locale: $locale
    ) {
      user {
        id
        uuid
        name
        email
        metaType
        phoneNumber
        isOauth
      }
      token
      returnMessage {
        status
        message
      }
    }
  }
`;

export interface AdminLoginData {
  adminLogin: {
    user?: User;
    token: string;
    returnMessage: ReturnMessage;
  };
}

export interface AdminLoginVariables {
  email: string;
  password: string;
  eval: boolean;
  locale: string;
}
